<template>
	<div class="sales">
		<HNB single-title="全网销量TOP5产品"></HNB>
		<div style="width: 100%;position: relative;">
			<div class="sales-banner" v-for="item in centertotal" v-show="bottomactive==item.active">
				<img :src="item.banner" />
				<div style="width:65.125rem;height: 100%; position: absolute;left:0;top:0;right:0;bottom:0; margin:auto; ">
					<SvgIcon :svg-name="item.svgName" size="100" style="position: absolute;left:0;top: 25%;z-index: 98;"></SvgIcon>
				</div>
				<div class="bannershell">
				</div>
				<div class="bannerinfo" v-for="item in bannertotal" v-show="bottomactive==item.active">
					<div class="infobox1">{{item.title}}</div>
					<div class="infobox2">{{item.info}}</div>
					<div class="infobox3" @click="openherf(item.active)">进一步了解></div>
				</div>
			</div>
		</div>
		<div class="sales-center" v-for="item in centertotal" v-show="bottomactive==item.active">
			<div class="left" style="position: relative;">
				<SvgIcon :svg-name="item.svgName" size="80" style="position: absolute;right: 5%;top: 12%;z-index: 98;"></SvgIcon>
				<div class="left-box1 animated fadeIn" v-for="(e,i) in item.write" v-show="num == i">{{e.title}}</div>
				<div class="left-box2 animated fadeIn" v-for="(e,i) in item.write" v-show="num == i">{{e.letter}}</div>
				<div style="display: flex; padding-left: 18%;padding-top: 5%;">
					<div class="left-box3" v-for="(e,i) in 3" :class="{'active':num==i}">
					</div>
				</div>
			</div>
			<div class="right " v-for="item in centertotal" v-show="bottomactive==item.active">
				<img class="animated fadeIn " v-for="(e,i) in item.imgurl" :src="e.img" v-show="num == i" />
			</div>

		</div>

		<div class="sales-bottom">
			<div class="sales-shell" v-for="(item,i) in bottomtotal" :class="{'active':item.active==bottomactive}" @click="choose(item.active)">
				<div class="sales-shell-top">{{item.top}}</div>
				<div class="sales-shell-img">
					<SvgIcon :svg-name="item.svgName" size="40" style="position: absolute;right: -65%;top: -30%;z-index: 98;"></SvgIcon>
					<img :src="item.image" />
				</div>
				<div class="sales-bottom-title">{{item.info1}}</div>
				<div class="sales-bottom-write">{{item.info2}}</div>
			</div>
		</div>
		<bottom :BsTitle="bsTitle"></bottom>
	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/bottomShow.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	export default {
		name: 'sales',
		data() {
			return {
				flag: true,
				bottomactive: 'molitie',
				num: '0',
				bsTitle: ['销量领先产品'],
				bannertotal: [{
						title: '随身魔力按摩贴',
						info: '随身按摩|手法多样|一指操控|小巧便捷',
						active: 'molitie'
					},
					{
						title: '揉捏按摩靠枕',
						info: '3D按摩|PTC热敷|无线便携|强劲扭力',
						active: 'kaozhen'
					},
					{
						title: '眼部冷热按摩仪',
						info: '冷热双感敷眼|自动感应按摩|一键式操作|小巧便携',
						active: 'coldhot'
					},
					{
						title: '护腰塑形坐垫',
						info: '矫正坐姿|护腰塑臀|立体包裹|形体支撑',
						active: 'zuodian'
					},
					{
						title: '人体工学可调背靠',
						info: '环抱式承托|一件升降|扭簧设计|久坐不累',
						active: 'kaobei'
					}
				],
				bottomtotal: [{
						top: 'TOP 1',
						svgName:'',
						image: this.GLOBAL.imgHost + '/images/sales/bottom1.png',
						info1: '随身魔力按摩贴',
						info2: '口袋里的魔术师',
						
						active: 'molitie'
					},
					{

						top: 'TOP 2',
						svgName:'IF',
						image: this.GLOBAL.imgHost + '/images/sales/bottom2.png',
						info1: '揉捏按摩靠枕',
						info2: '不止舒适 更好看 ',
						active: 'kaozhen'
					},
					{

						top: 'TOP 3',
						svgName:'',
						image: this.GLOBAL.imgHost + '/images/sales/bottom3.png',
						info1: '眼部冷热按摩仪',
						info2: '多效合一 宠爱你的双眼',
						active: 'coldhot'

					},
					{

						top: 'TOP 4',
						svgName:'',
						image: this.GLOBAL.imgHost + '/images/sales/bottom4.png',
						info1: '护腰塑形坐垫',
						info2: '你的私人坐姿矫正专家 ',
						active: 'zuodian'

					},
					{

						top: 'TOP 5',
						svgName:'IF',
						image: this.GLOBAL.imgHost + '/images/sales/bottom5.png',
						info1: '人体工学可调背靠',
						info2: '科学塑形 舒适倚靠',
						active: 'kaobei'

					}
				],
				centertotal: [{
						banner: this.GLOBAL.imgHost + '/images/sales/banner1.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/anmotie1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/anmotie2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/anmotie3.jpg'
							},
						],
						write: [{
								title: '随心随行 想按就按',
								letter: '放进口袋，随身携带，生活中、旅途中、运动中，只要你想，随时拿出它，给自己疲惫的身体一点完全偷懒的自由！'
							},
							{
								title: '传统与科技的领先结合 有助于缓解肌肉不适和疲劳',
								letter: '采用TENS低频脉冲按摩技术，有助于缓解肌肉疼痛与疲劳。大师级按摩手法，畅通经络、舒缓神经快速恢复机体活力。'
							},
							{
								title: '各部位通用 哪里酸痛贴哪里',
								letter: '随心移位，肩部、背部、腰部、四肢等部位都适用。'
							},
						],
						active: 'molitie',
					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner2.jpg',
						svgName:'IF',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/kaozhen1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/kaozhen2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/kaozhen3.jpg'
							},
						],
						write: [{
								title: '放松不受限 随时给身体充电',
								letter: '走心设计，摆脱传统电源线的束缚，随时随地都可以给自己解压，帮助恢复身体活力!'
							},
							{
								title: '强劲扭力 揉碎肌肉下的酸痛',
								letter: '产品纯铜线电机低噪耐用，持续稳定的动能可以支撑大马力作用，强劲力道直击酸痛处，揉碎肌肉下深层的疲惫感，让身体得到更深入的按摩。'
							},
							{
								title: '一键式操作 简单易用',
								letter: '长按开关机开启/关闭按摩模式，再次短按开启加热按摩模式。'
							},
						],
						active: 'kaozhen',

					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner3.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/coldhot1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/coldhot2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/coldhot3.jpg'
							},
						],
						write: [{
								title: '多屏时代 您的双眼已经重度疲惫',
								letter: '眼镜是心灵的窗口，但生活在快节奏的多屏时代，长时间和电脑手机对视，人均每天用眼超过16小时，眨眼次数超过10000次，眼部问题接踵而来。一款冷热按摩仪可以给你的眼睛做SPA，帮你打开心灵之窗，感受更美视界。'
							},
							{
								title: '冰爽提神 减少眼部浮肿',
								letter: '开启Refresh模式，18℃的冰感能快速赶走疲惫，减少眼部浮肿，让忙碌一天的双眸“睛”力更充沛。'
							},
							{
								title: '温热舒缓 缓解眼部疲劳',
								letter: '40℃恒热是缓解敏感眼部肌肤的最佳温度，开启Relieve模式后，将产品覆盖眼部，让眼部四周渐进感受到温柔的暖意，释放眼睛疲劳。'
							},
						],
						active: 'coldhot',

					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner4.jpg',
						svgName:'',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/zuodian1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/zuodian2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/zuodian3.jpg'
							},
						],
						write: [{
								title: '你的私人坐姿矫正专家',
								letter: '坐姿不正容易导致肩颈酸痛、驼背、臀部扁平外扩。人体工程学设计、护腰分区支撑系统，保持腰部脊柱呈现自然s型曲线，3D立体包裹，矫正“假胯宽”，矫正骨盆前倾或后倾，防止驼背，轻松“坐”出蜜桃臀，修饰好身材。'
							},
							{
								title: '分区支撑系统 均衡承载体重',
								letter: '人体工程学设计、护腰分区支撑系统，贴合人体曲线，全方位支撑你的腰背，帮助脊柱保持自然生理曲线，保持正确坐姿。'
							},
							{
								title: '多种场景 多种生活享受',
								letter: '上班工作8小时，均衡释放压力。办公椅放上乐班护腰塑形坐垫，缓解脊柱压力，让你保持正确坐姿，防止驼背'
							},
						],
						active: 'zuodian',

					},
					{
						banner: this.GLOBAL.imgHost + '/images/sales/banner5.jpg',
						svgName:'IF',
						imgurl: [{
								img: this.GLOBAL.imgHost + '/images/sales/beikao1.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/beikao2.jpg'
							},
							{
								img: this.GLOBAL.imgHost + '/images/sales/beikao3.jpg'
							},
						],
						write: [{
								title: '反正都要坐着 为什么不坐的舒服一点',
								letter: '你的一天，超过三分之一的时间都是坐着的状态。然而，大部门的脊椎疾病都是由错误的坐姿所导致。乐范人机工学靠垫，动态承托背部、缓解脊椎压力，怎么靠都舒适。'
							},
							{
								title: '创新一键升降 舒适随心选择',
								letter: '乐班人机工学靠垫内置升降式机械结构，无需工具即可根据自身需要一键完成动态升降，调整后两侧高度一致，滑槽式设计不易滑落，让依靠更舒适。'
							},
							{
								title: '硬核设计 可刚可柔清爽透气',
								letter: '乐班人机工学靠垫的背托共有306个透气孔，硬核设计双面透气，夏季使用更清爽。同时预留配件安装孔，可搭配使用海绵软垫，所选用的复合纤维麻灰布搭配质感柔软的原生海绵，冬天使用柔软保暖。'
							},
						],
						active: 'kaobei',

					},
				]
			}
		},
		components: {
			HNB,
			bottom,
			SvgIcon
		},
		mounted() {
			this.play()
		},
		methods: {
			autoplay() {
				this.num++
				if (this.num == 3) {
					this.num = 0
				}
			},
			play() {
				setInterval(this.autoplay, 5000)
			},
			choose(e) {
				// console.log("e", e)
				let that = this
				that.bottomactive = e
			},
			openherf(url) {
				let routeUrl = this.$router.resolve({
					path: "/Productstation",
					query: {
						globalname: url
					}
				});
				window.open(routeUrl.href, '_blank');
				// console.log("url", url)
			}
		}
	}
</script>

<style>
	@import url("../common/animate.min.css");

	.bannerinfo {
		width: 100%;
		height: 100%;
		/* line-height: 100%; */
		position: absolute;
		top: 0%;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		
	}

	.bannerinfo .infobox1 {
		font-size: 2rem;
		font-family: 'Alibaba-PuHuiTi-M';
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		letter-spacing: 3px;

	}

	.bannerinfo .infobox2 {
		font-size: 1rem;
		 
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		letter-spacing: 3px;
		padding-top: 1%;
	}

	.bannerinfo .infobox3 {
		font-size: 0.9rem;
		 
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		cursor: pointer;
		padding-top: 3%;
	}

	.sales {
		/* width: 64rem; */
		margin: 0 auto;
	}

	.bannershell {
		width: 100%;
		height: 100%;
		position: absolute;
		background: rgba(0, 0, 0, 1);
		opacity: 0.6;
		top: 0%;
	}

	.sales .sales-banner {
		width: 100%;
		font-size: 0;
		position: relative;
	}

	.sales .sales-banner img {
		width: 100%;
	}

	.sales .sales-center {
		width: 100%;
		display: flex;
	}

	.sales .sales-center .left {
		width: 50%;
		background: rgba(244, 244, 244, 1);
	}

	.sales .sales-center .left .left-box1 {
		width: 100%;
		font-size: 18px;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		line-height: 30px;
		text-align: left;
		padding-left: 20%;
		padding-right: 20%;
		padding-top: 17%;
		animation-duration: 2s;
	}

	.sales .sales-center .left .left-box2 {
		font-size: 0.85rem;
		height: 3.75rem;
		 
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
		text-align: left;
		padding-left: 20%;
		padding-right: 20%;
		padding-top: 1rem;
		animation-duration: 2s;
	}

	.sales .sales-center .left .left-box3 {
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		background: rgba(215, 215, 215, 1);
		margin-left: 2%;
	}

	.sales .sales-center .left .left-box3.active {
		background: rgba(0, 199, 133, 1) !important;
		border: 0.0625rem !important;
	}

	.sales .sales-center .right {
		width: 50%;
	}

	.sales .sales-center .right img {
		width: 100%;
		height: 100%;
		animation-duration: 3s;
	}

	.sales .sales-bottom {
		display: flex;
		width: 90%;
		margin: 0 auto;
		margin-top: 3.125rem;
		margin-bottom: 7rem;
		align-items: center;
		justify-content: center;
	}

	.sales .sales-bottom .sales-shell {
		width: 190px;
		height: 190px;
		background: rgba(244, 244, 244, 1);
		margin-left: 0.5%;
		margin-right: 0.5%;
		/* padding-bottom: 1.5rem; */
		cursor: pointer;
	}

	.sales .sales-bottom .sales-shell.active {

		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1rem 1rem 0px rgba(41, 44, 51, 0.1) !important;
		border: 0.0625rem !important;
	}

	.sales .sales-bottom .sales-shell-top {
		width: 3rem;
		height: 0.9375rem;
		background: rgba(0, 199, 133, 1);
		border-radius: 1.125rem;
		color: white;
		font-weight: 550;
		font-size: 10px;
		margin-top: 0.625rem;
		margin-left: 0.625rem;
		padding: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.sales .sales-bottom .sales-shell-img {
		width: 40%;
		height: 40%;
		margin: 0 auto;
		position: relative;
		/* padding-top: 0.625rem; */
	}

	.sales .sales-bottom .sales-shell-img img {
		width: 100%;
	}

	.sales .sales-bottom .sales-bottom-title {

		font-size: 0.9rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(29, 29, 29, 1);
		line-height: 30px;
		padding-top: 1.1rem;
	}

	.sales .sales-bottom .sales-bottom-write {
		font-size: 0.7rem;
		 
		font-weight: 400;
		color: rgba(29, 29, 29, 1);
	}
</style>
